import {
  projectVar,
} from './variables';

export const localProject = () => {
  return projectVar();
}